export default "__VITE_ASSET__d19c8e20__"